import React from 'react';
import GoogleAnalytics from 'react-ga';
import { NavLink } from 'react-router-dom';
import './Footer.css'

import { Icon } from '@blueprintjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faTwitter, faGoogle, faWordpress } from '@fortawesome/free-brands-svg-icons'
import imgNtLogo from '../../assets/images/NOVATEC-rgb-weiss-cyan-tuerkis_schutz.png'



const SocialLink = ({ name, faIcon, link, event }) => (
    <GoogleAnalytics.OutboundLink className="footer--social" eventLabel={event} to={link} target="_blank" rel="noopener noreferrer">
        <div className="footer--social--icon"><FontAwesomeIcon icon={faIcon} size="2x" /></div>
        <span className="footer--social--name">{name}</span>
    </GoogleAnalytics.OutboundLink>
)

class Footer extends React.Component {

    render() {
        return (
            <footer>
                <div className="footer--width-limiter">
                    <div className="footer--cell">
                        <GoogleAnalytics.OutboundLink className="footer--love" eventLabel="Footer-NT-APM" to="https://www.novatec-gmbh.de/en/consulting/open-digital-experience-management/" target="_blank" rel="noopener">
                            OpenAPM is powered and made with <Icon icon="heart" className="footer--love--heart" /> by
                            <img className="footer--love--novatec" src={imgNtLogo} alt="Novatec Consulting GmbH" />
                        </GoogleAnalytics.OutboundLink>
                    </div>
                    <div className="footor--h-line" />
                    <div className="footer--cell">
                        <div className="footer--social-wrapper">
                            <SocialLink name="Github" faIcon={faGithub} link="https://github.com/openapm" event="Footer-GitHub" />
                            <SocialLink name="Twitter" faIcon={faTwitter} link="https://twitter.com/openapmio" event="Footer-Twitter" />
                            <SocialLink name="Google Groups" faIcon={faGoogle} link="https://groups.google.com/forum/#!forum/openapm" event="Footer-Forum" />
                            <SocialLink name="Blog" faIcon={faWordpress} link="https://www.novatec-gmbh.de/blog/category/openapm/" event="Footer-Blog" />
                        </div>
                    </div>
                    <div className="footor--h-line" />
                    <div className="footer--cell footer--links">
                        <NavLink className="imprint-link footer--group" to="/imprint" >Imprint</NavLink>
                        <span className="footer--v-limiter footer--text">|</span>
                        <NavLink className="imprint-link footer--group" to="/privacy" >Privacy Policy</NavLink>
                        <div className="footer--group">
                            <span className="footer--v-limiter footer--text">|</span><span className="footer--text"> Newsletter</span>
                            <a className="imprint-link" target="_blank" rel="noopener noreferrer" href="http://eepurl.com/dAwsGL">subscribe</a>
                            <span className="footer--text"> / </span>
                            <a className="imprint-link" target="_blank" rel="noopener noreferrer" href="https://openapm.us18.list-manage.com/unsubscribe?u=9134632785ec991199fd5aedd&id=a6dd204bac">unsubscribe</a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js